import { FeedStore } from '@creative/elements/feed/feed-store';

export class FeedStoreSingleton {
    private static feedStore: FeedStore;

    static getInstance(): FeedStore {
        if (!FeedStoreSingleton.feedStore) {
            throw new Error('FeedStore not initialized');
        }
        return FeedStoreSingleton.feedStore;
    }

    static initialize(brandId: string): void {
        if (FeedStoreSingleton.feedStore) {
            return;
        }
        FeedStoreSingleton.feedStore = new FeedStore(brandId);
    }
}
